import { StateCreator } from "zustand";
import { ReportDetailState } from "../interface";
import {
  calculateSectionListRecords,
  cleanOpenSections,
  isActiveSectionValid,
} from "../utils";

export interface DerivedActions {
  recalculateSectionList: () => void;
}

/**
 * Actions que derivam ou recalculam estado baseado em outros estados
 */
export const createDerivedActions: StateCreator<
  ReportDetailState & { actions: any },
  [],
  [],
  DerivedActions
> = (set, get) => ({
  recalculateSectionList: () => {
    const currentState = get();
    const { sections, reportType, selectedCombinedFilter } = currentState.data;
    const { openSections, activeSection } = currentState.ui;

    const { sectionListRecords, totalRecords } = calculateSectionListRecords(
      sections,
      reportType,
      selectedCombinedFilter
    );

    // Limpa seções abertas que não existem mais
    const validSectionIds = new Set(
      sectionListRecords.map((s: any) => s.interface_id).filter(Boolean)
    );

    const cleanedOpenSections = cleanOpenSections(
      openSections,
      validSectionIds,
      sectionListRecords
    );

    // Valida se a seção ativa ainda existe
    const isValid = isActiveSectionValid(
      activeSection,
      validSectionIds,
      sectionListRecords
    );

    set((state) => ({
      ui: {
        ...state.ui,
        sectionListRecords,
        totalRecords,
        openSections: cleanedOpenSections,
        activeSection: isValid ? activeSection : null,
      },
    }));
  },
});
